import React from "react";
import Loader from "../Loader";

// Enregistrement en cours à la fin d'un formulaire : message d'attente de la
// charte (fond bleu pâle, encre foncée) au lieu d'un aplat vert à texte blanc.
const LoaderFinish = ({ text }) => {
  return (
    <div className="form-attente" role="status" aria-live="polite">
      <Loader />
      <p>{text}</p>
    </div>
  );
};

export default LoaderFinish;
